import { useEffect } from 'react';

import { Navigate } from '@sorare/routing';
import {
  ANY_SPORT_ONBOARDING_PRO,
  ANY_SPORT_ONBOARDING_TUTORIAL,
  ANY_SPORT_SERIES_ONBOARDING_SELECT_COMPETITION,
} from '@sorare/core/src/constants/__generated__/routes';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useLocalStorage } from '@sorare/core/src/hooks/useLocalStorage';
import { useFootballEvents } from '@sorare/marketplace/src/shared/events/lib';

const ProOnboardingPage = () => {
  const track = useFootballEvents();
  const { generateSportContextPath } = useSportContext();
  const { footballUserProfile } = useCurrentUserContext();
  const [onboardingPro] = useLocalStorage('ONBOARDING_PRO', undefined);

  useEffect(() => {
    track('Enter General Tutorial');
  }, [track]);

  if (footballUserProfile?.forceToProOnboarding) {
    return (
      <Navigate
        to={generateSportContextPath(ANY_SPORT_ONBOARDING_PRO)}
        replace
      />
    );
  }

  if (onboardingPro) {
    return (
      <Navigate
        to={generateSportContextPath(ANY_SPORT_ONBOARDING_TUTORIAL)}
        replace
      />
    );
  }

  return (
    <Navigate
      to={generateSportContextPath(
        ANY_SPORT_SERIES_ONBOARDING_SELECT_COMPETITION
      )}
      replace
    />
  );
};

export default ProOnboardingPage;
